//식재

import { useRecoilValue } from 'recoil'
import { userInfoState } from 'store/atom/user-state-atom'
import { IconButton, Image, InfoList, ListTitle, Tag } from 'components'

import { useFdingrDtl } from 'api/menucrte/menucrtcarte-fetch'
import useModal from 'hook/useModal'
import { getHashTag } from 'utils/common-util'
import { formatNumberComma } from 'utils/format-util'
import { useEffect, useState } from 'react'

// css
import 'assets/style/common.scss'
import 'assets/style/elements/info-list.scss'
import { queryClient } from 'index'

function Ingredients({ info }) {
  const userInfo = useRecoilValue(userInfoState)
  const { openCmowEmp, closeModal } = useModal()
  const [isInit, setIsInit] = useState(false)
  const { isSuccess, data } = useFdingrDtl(
    {
      ...info,
      searchCoId: userInfo.coId,
      searchSiteId: userInfo.siteId,
    },
    isInit,
  )

  useEffect(() => {
    setIsInit(true)
    return () => {
      queryClient.removeQueries('fdingrDtl')
    }
  }, [])
  return (
    <>
      <section className={`popup-wrap  show`}>
        <section className={`popup-window`} style={{ height: '100%' }}>
          <section className="body">
            <header className={`site-header site-header-popup`}>
              <div className="row relative">
                <h1 className={'heading f-16 f-bold'} style={{ padding: '0 80px' }}>
                  {data?.name || ''}
                </h1>
                <div className="right">
                  <IconButton
                    size="40"
                    type="share"
                    onClick={() => {
                      openCmowEmp({ ...info, dvsn: 'F' })
                    }}
                  />
                  <IconButton size="40" type="close" onClick={closeModal} />
                </div>
              </div>
            </header>
            {isSuccess && (
              <div className="wrapper" style={{ marginBottom: '24px' }}>
                <div>
                  <Image
                    className="mt16 mb16"
                    src={process.env.REACT_APP_PRODUCT_MENU_IMAGE_URL + '/' + data?.imgUrl}
                    cTTL={true}
                    imgStyle={{ width: '100%' }}
                  />
                </div>
                <ListTitle title="식재기본정보" className="border-black mt16" border="true" />
                <InfoList
                  className="mt8"
                  titleWidth="85px"
                  data={[
                    {
                      id: 1,
                      title: '표시',
                      data: <Tag className="mb0" data={getHashTag(data, true)} />,
                    },
                    {
                      id: 2,
                      title: '상태',
                      data: (
                        <div className="flex flex-item-center">
                          <span className="mr4">{data.gdUsSttsNm}</span>
                          {/* <span className="state-dot success" /> */}
                        </div>
                      ),
                    },
                    { id: 3, title: '상품코드', data: data.code },
                    { id: 4, title: '상품명', data: data.name },
                    { id: 5, title: '식재세분류', data: data.bigrGrpClsNm },
                    { id: 6, title: '주문단위', data: data.ordrUnitCd },
                    { id: 7, title: '포장단위입수량', data: data.hghtUnitCtcntQty },
                    { id: 8, title: '저장조건', data: data.strgCondNm },
                    { id: 9, title: '원산국', data: data.crtMngClNm },
                    { id: 10, title: '주문가', data: formatNumberComma(data?.trfUnprc) + ' 원/' + data.ordrUnitCd },
                    { id: 11, title: '100g단가', data: formatNumberComma(data.gtrfUnprc) + '원' },
                    { id: 12, title: '협력사', data: data.bcnrNm },
                    { id: 12, title: '비고', data: data.rmk },
                    //   {
                    //     id: 13,
                    //     title: '비고',
                    //     data: (
                    //       <>
                    //         수입지연으로 인한 일시 제어
                    //         <br />
                    //         (2/9~5/31)
                    //       </>
                    //     ),
                    //   },
                  ]}
                />
              </div>
            )}
          </section>
        </section>
      </section>
    </>
  )
}

export default Ingredients
